export interface VolunteerApplication {
  id: string;

  name: string;
  surname: string;
  email: string;

  createdAt: Date;
  updatedAt: Date;
};